import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const StyledContent = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 20% 1fr;
  gap: ${({ theme }) => theme.spacing.medium};
  margin-top: ${({ theme }) => theme.spacing.medium};

  aside {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
  }

  @media (max-width: 1500px) {
    grid-template-columns: 30% 1fr;
  }

  @media (max-width: 1077px) {
    grid-template-columns: 1fr;
  }
`;

interface NgGridLayoutProps {
  children?: ReactNode;
}

export const NgGridLayout: FC<NgGridLayoutProps> = ({ children }) => {
  return <StyledContent>{children}</StyledContent>;
};
